const BASESITEID = 'mdt_b2bsite_us';

export const shareTemplateEndpoint = (baseSiteId) =>
    `occ/v2/${baseSiteId}/templates/shareTemplate`;

export const updateProductTemplateEndpoint = () =>
    `/occ/v2/${localStorage.getItem('baseSiteId')}/templates`;

export const deleteTemplateEndpoint = (queryParams) =>
    `occ/v2/${localStorage.getItem('baseSiteId')}/templates/${queryParams}`;

export const createEquityProductTemplateEndpoint = (salesOrg) =>
    `/occ/v2/${salesOrg}/templates`;

export const getUserListEndpoint = (params) =>
    `occ/v2/${localStorage.getItem('baseSiteId')}/users?${params}`;
